<template>
  <div class="page">
    <div class="admin">
      <h2>Livros</h2>
      <el-form>
        <el-row :gutter="40">
          <el-col :xs="24" :sm="10" :md="8">
            <el-form-item label="Título">
              <el-input
                placeholder="Insira o título da obra"
                v-model="title"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="10" :md="8">
            <el-form-item label="Código">
              <el-input
                placeholder="Insira o codigo da obra"
                v-model="code"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="10" :md="8">
            <el-form-item label="Autor">
              <el-input
                placeholder="Insira o autor da obra"
                v-model="author"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="Ano de Publicação">
              <br />
              <el-date-picker
                type="year"
                placeholder="Escolha um ano"
                v-model="year"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-row>
          <el-button type="primary" @click="findBooks()">Buscar</el-button>
          <el-button @click="$router.push('/admin/create')">Criar</el-button>
        </el-row>
      </el-form>
    </div>
    <br />
    <el-table :data="data.items">
      <el-table-column prop="code" label="Código" width="180">
      </el-table-column>
      <el-table-column prop="title" label="Título" width="180">
      </el-table-column>
      <el-table-column prop="authors" label="Autor(es)"> </el-table-column>
      <el-table-column prop="publisher" label="Editora"> </el-table-column>
      <el-table-column prop="year" label="Ano"> </el-table-column>
      <el-table-column fixed="right" label="Operações" width="120">
        <template v-slot="scope">
          <el-button @click="itemDetails(scope.row)" type="text" size="small"
            >Detalhar</el-button
          >
          <el-button @click="deleteBook(scope.row)" type="text" size="small"
            >Deletar</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-size="data.page_size"
      layout="prev, pager, next"
      :total="data.count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { searchBooks, deleteBook } from "../../../services/book";
export default {
  data() {
    return {
      current_page: 1,
      title: "",
      code: "",
      author: "",
      year: null,
      data: {},
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.current_page = val;
      this.findBooks();
    },
    findBooks() {
      const params = {};
      if (this.current_page) {
        params.page = this.current_page;
      }
      if (this.title) {
        params.title = this.title;
      }
      if (this.code) {
        params.code = this.code;
      }
      if (this.author) {
        params.author = this.author;
      }
      if (this.year) {
        params.year = this.year.getFullYear();
      }
      searchBooks(params).then((response) => {
        this.data = response.data;
      });
    },
    itemDetails(arg) {
      this.$router.push(`/admin/books/${arg._id.$oid}`);
    },
    async deleteBook(book) {
      const should_delete = await this.$confirm(
        "Essa é uma operação definitiva. Tem certeza que deseja continuar?",
        "Atenção",
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      );
      if (should_delete) {
        const response = await deleteBook(book._id.$oid);
        if (response.status === 204) {
          this.$message.success("Livro deletado com sucesso!");
          this.findBooks();
        }
      }
    },
  },
  created() {
    this.findBooks();
  },
};
</script>

<style scoped>
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
h2 {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
.admin {
  margin-left: 30px;
  margin-right: 30px;
}

.page {
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 2%;
}
</style>
